// src/components/WalletBillingTabs.jsx
// Route-based tab bar shared by PatientWalletPage and PatientSubscriptionPage.
// The two pages are separate routes (/patient/wallet, /patient/subscription)
// but present as one "Wallet & Billing" destination in the sidebar — this is
// what makes them read as tabs of the same section instead of two unrelated
// pages.

import React from 'react';
import { NavLink } from 'react-router-dom';

export default function WalletBillingTabs() {
  return (
    <div className="tabs-bar" style={{ maxWidth: 560, margin: '0 auto 20px' }}>
      <NavLink
        to="/patient/wallet"
        end
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Wallet
      </NavLink>
      <NavLink
        to="/patient/subscription"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Subscription
      </NavLink>
      <NavLink
        to="/patient/invoices"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Invoices
      </NavLink>
    </div>
  );
}
